<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <dis-prod />
      </div>
    </div>
</section>
</template>

<script>
import disProdTemp from './Temp/DisScheduleProdTemp.vue'

export default {
  name: 'Tables',
  components: {
    'dis-prod': disProdTemp
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CrDisableSchedule.vue?31af9f18